import React from 'react';
import Router from './Router';
import './app.css';
import Snackbar from './containers/Snackbar';

const App = () => {
    return (
        <div id="wrap_all">
            <Router/>
            <Snackbar/>
        </div>
    );
};

export default App;
